<div class="modal-header">
  <h3 class="modal-title">
    {{ 'competitionModule.possibleDuplicate' | translate }}
  </h3>

  <button
    type="button"
    class="btn-close"
    attr.aria-label="{{ 'wcag.close' | translate }}"
    (click)="onClickClose()"
  >
  </button>
</div>
<div *ngIf="!showExistingTeams" class="modal-body">
  <p>
    {{ 'competitionModule.hi' | translate }} {{ currentMember.firstName }}!
  </p>
  <p>{{ 'competitionModule.greatSignUp' | translate }}</p>
  <p>{{ 'competitionModule.justToBeSure' | translate }}</p>
  <ul>
    <li *ngFor="let team of teamsOfMember">
      {{ team?.description }}
    </li>
  </ul>
  <p>{{ 'competitionModule.areYouSure' | translate }}</p>

  <div class="row">
    <div class="col-md-6">
      <button
        type="button"
        (click)="onClickConfirmSettings()"
        class="btn btn-primary w-100 h-100"
      >
        {{ 'competitionModule.checkAndConfirmSettings' | translate }} <br />
      </button>
    </div>

    <div class="col-md-6">
      <button
        type="button"
        (click)="onFormSubmit()"
        class="btn btn-primary w-100 h-100"
      >
        {{ 'competitionModule.createNewTeam' | translate }}
      </button>
    </div>
  </div>
</div>
<div class="modal-body" *ngIf="showExistingTeams">
  <form
    [formGroup]="form"
    (ngSubmit)="onSelectTeamFormSubmit()"
    #formRef="ngForm"
  >
    <div class="mt-3">
      <p>{{ 'competitionModule.selectOneExistingTeam' | translate }}</p>

      <select
        attr.aria-label="{{ 'wcag.selectTeam' | translate }}"
        formControlName="selectedTeamId"
        [attr.aria-invalid]="
          form.controls.selectedTeamId.dirty &&
          form.controls.selectedTeamId.invalid
            ? 'true'
            : null
        "
        class="form-select"
      >
        <option [ngValue]="null" selected>
          {{ 'general.select' | translate }}
        </option>
        <option *ngFor="let team of teamsOfMember" [value]="team.id">
          {{ team.description }}
        </option>
      </select>
    </div>
    <div class="row mt-3 d-flex justify-content-between ps-3 pe-3">
      <div class="col-3">
        <button
          type="button"
          class="btn btn-soft-primary"
          (click)="showExistingTeams = false"
        >
          {{ 'general.back' | translate }}
        </button>
      </div>
      <div class="col-3">
        <button class="btn btn-primary" [disabled]="!form.dirty" type="submit">
          {{ 'general.done' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
